export const INTERSECT_THRESHOLD = 0.2
